var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgJiesuan = function SvgJiesuan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "url(#jiesuan_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.059 14.53C11.16 14.53 8 12.843 8 10.764 8 8.685 11.16 7 15.059 7c3.898 0 7.059 1.686 7.059 3.765s-3.16 3.764-7.06 3.764Zm-2.26-6.4a.47.47 0 0 1 .658-.095l1.6 1.2 1.6-1.2a.47.47 0 1 1 .565.753l-.753.565h.94a.47.47 0 1 1 0 .941h-1.881v.941h2.353a.47.47 0 1 1 0 .942h-2.353v.94a.47.47 0 0 1-.942 0v-.94h-2.353a.47.47 0 0 1 0-.942h2.353v-.94h-1.882a.47.47 0 0 1 0-.942h.941l-.753-.565a.47.47 0 0 1-.094-.659ZM8 11.234C8 13.315 11.16 15 15.059 15c3.898 0 7.059-1.685 7.059-3.765v2.353c0 2.08-3.16 3.765-7.06 3.765C11.16 17.353 8 15.667 8 13.588v-2.353Zm7.059 6.588C11.16 17.823 8 16.139 8 14.06v2.353c0 2.079 3.16 3.765 7.059 3.765 3.898 0 7.059-1.686 7.059-3.765v-2.353c0 2.079-3.16 3.764-7.06 3.764Zm0 2.824C11.16 20.647 8 18.962 8 16.882v2.353C8 21.315 11.16 23 15.059 23c3.898 0 7.059-1.686 7.059-3.765v-2.353c0 2.08-3.16 3.765-7.06 3.765Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jiesuan_svg__a",
    x1: 15.5,
    y1: 0,
    x2: 15.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA7EF"
  })))));
};

export default SvgJiesuan;